import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CalendarCheck, LifeBuoy, FileCheck2, ChevronRight } from "lucide-react";

const PHASES = [
  {
    icon: CalendarCheck, title: "Before your rental", items: [
      ["Doorstep delivery in as little as 3 hours, or pick up at any of our 14 branches", "/locations"],
      ["Digital check-in and document upload from your phone in about 2 minutes", "/account?tab=documents"],
      ["Flight tracking on airport pickups, so if you land late your car still waits", "/help"],
    ],
  },
  {
    icon: LifeBuoy, title: "During your rental", items: [
      ["24/7 roadside assistance anywhere in the UAE, on 800 EUROPCAR", "/help"],
      ["Extend, swap your car or book a service from your account", "/account?tab=services"],
      ["Had an accident? Report it online with photos and we handle the rest", "/report-accident"],
    ],
  },
  {
    icon: FileCheck2, title: "After your rental", items: [
      ["Download invoices & rental agreements any time", "/account?tab=history"],
      ["Deposit released within 21 working days — tracked in your account", "/account?tab=billing"],
      ["Tolls & fines itemised transparently — dispute in one click", "/account?tab=billing"],
    ],
  },
];

export const LifecycleStrip = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-white border-y border-[#E2E8F0]" data-testid="lifecycle-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="promo-stripe mb-8">
          <h2 className="heading-upper text-2xl sm:text-3xl text-[#144733]">{t("With you at every step")}</h2>
          <p className="text-sm text-[#57685e] mt-1">{t("Booking is just the start. Here's how we look after you before, during and after every rental.")}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {PHASES.map((p, i) => (
            <div key={p.title} className="bg-[#fafcfa] border border-[#e2ebe4] rounded-2xl p-6" data-testid={`lifecycle-phase-${i + 1}`}>
              <p.icon className="w-7 h-7 text-[#009900] mb-3" />
              <h3 className="font-bold text-[#0F1E17] mb-3">{t(p.title)}</h3>
              <ul className="space-y-2.5">
                {p.items.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="flex gap-2 text-sm text-[#57685e] hover:text-[#005125] transition-colors group">
                      <ChevronRight className="w-4 h-4 text-[#009900] shrink-0 mt-0.5 group-hover:translate-x-0.5 transition-transform" />{t(label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
